import { useNavigate } from 'react-router-dom';
import './ResultItem.css';

export const ResultItem = (props) => {
  const { room } = props;
  const navigate = useNavigate();

  const navToRoom = () => {
    navigate(`/room/${room.label.toLowerCase().replace(/\s/g, '_')}`);
  };

  return (
    <div
      className={`search-result__list__item ${room.label === 'SERVICE MÉDICAL' ? 'fixed' : ''}`}
      onClick={navToRoom}
    >
      <div className="search-result__list__item__text">{room.label}</div>
    </div>
  );
};
